(function () {

  // ─── Warehouse config ────────────────────────────────────────────────
var WAREHOUSES = {
  NJ:           'EZ Pools New Jersey',
  CO:           'EZ Pools Colorado',
  Memphis:      'EZ Pools Memphis',
  Jacksonville: 'EZ Pools Jacksonville'
};

  var ZIP_MAP = {
    '06': WAREHOUSES.NJ,  '07': WAREHOUSES.NJ,  '08': WAREHOUSES.NJ,
    '10': WAREHOUSES.NJ,  '11': WAREHOUSES.NJ,  '12': WAREHOUSES.NJ,
    '13': WAREHOUSES.NJ,  '14': WAREHOUSES.NJ,  '15': WAREHOUSES.NJ,
    '16': WAREHOUSES.NJ,  '17': WAREHOUSES.NJ,  '18': WAREHOUSES.NJ,
    '19': WAREHOUSES.NJ,  '20': WAREHOUSES.NJ,  '21': WAREHOUSES.NJ,
    '22': WAREHOUSES.NJ,  '23': WAREHOUSES.NJ,
    '80': WAREHOUSES.CO,  '81': WAREHOUSES.CO,  '82': WAREHOUSES.CO,
    '83': WAREHOUSES.CO,  '84': WAREHOUSES.CO,  '85': WAREHOUSES.CO,
    '86': WAREHOUSES.CO,  '87': WAREHOUSES.CO,  '89': WAREHOUSES.CO,
    '90': WAREHOUSES.CO,  '91': WAREHOUSES.CO,  '92': WAREHOUSES.CO,
    '93': WAREHOUSES.CO,  '94': WAREHOUSES.CO,  '95': WAREHOUSES.CO,
    '96': WAREHOUSES.CO,  '97': WAREHOUSES.CO,  '98': WAREHOUSES.CO,
    '99': WAREHOUSES.CO,
    '30': WAREHOUSES.Memphis, '31': WAREHOUSES.Memphis, '32': WAREHOUSES.Jacksonville,
    '33': WAREHOUSES.Jacksonville, '34': WAREHOUSES.Jacksonville, '35': WAREHOUSES.Memphis,
    '36': WAREHOUSES.Memphis, '37': WAREHOUSES.Memphis, '38': WAREHOUSES.Memphis,
    '39': WAREHOUSES.Memphis, '40': WAREHOUSES.Memphis, '41': WAREHOUSES.Memphis,
    '42': WAREHOUSES.Memphis, '43': WAREHOUSES.Memphis, '44': WAREHOUSES.Memphis,
    '45': WAREHOUSES.Memphis, '46': WAREHOUSES.Memphis, '47': WAREHOUSES.Memphis,
    '48': WAREHOUSES.Memphis, '49': WAREHOUSES.Memphis, '70': WAREHOUSES.Memphis,
    '71': WAREHOUSES.Memphis, '72': WAREHOUSES.Memphis, '73': WAREHOUSES.Memphis,
    '74': WAREHOUSES.Memphis, '75': WAREHOUSES.Memphis, '76': WAREHOUSES.Memphis,
    '77': WAREHOUSES.Memphis
  };

// ─── NJ Local Pickup config ──────────────────────────────────────────
// Zip3 prefixes within ~50 miles of NJ warehouse (Williamstown, 08094)
var NJ_LOCAL_PICKUP_ZIPS = [
  // South Jersey
  '080', '081', '082', '083', '084', '085', '086',
  // Philadelphia + close suburbs (PA)
  '190', '191', '193', '194',
  // Wilmington / Newark (DE)
  '197', '198', '199'
];

function isLocalToNJ(zip) {
  if (!zip || zip.length < 3) return false;
  return NJ_LOCAL_PICKUP_ZIPS.indexOf(zip.substring(0, 3)) > -1;
}

  var FALLBACK_ORDER = [WAREHOUSES.Memphis, WAREHOUSES.Jacksonville, WAREHOUSES.NJ, WAREHOUSES.CO];
  var CUTOFF_HOUR_ET = 13; // 2 PM ET
  var ZIP_STORAGE_KEY = 'ez_zip'; // sessionStorage key

  // ─── Partner (Pool360) branch config ─────────────────────────────────
  // store_availabilities only lists pickup-enabled locations (the 4 above),
  // so stock held only at a Pool360 branch (Atlanta, CA, DFW, Houston, KS,
  // Phoenix) is invisible here. When the variant has stock but none of it is
  // at a warehouse we can see, show a conservative weekday-only estimate.
  var PARTNER_HANDLING_DAYS = 2; // weekdays before it leaves the branch ("1-2 business days", dated at 2)
  var PARTNER_TRANSIT_DAYS  = 3; // weekdays in transit, anywhere in the US

  // ─── Helpers ─────────────────────────────────────────────────────────
  function isDST(d) {
    var jan = new Date(d.getFullYear(), 0, 1).getTimezoneOffset();
    var jul = new Date(d.getFullYear(), 6, 1).getTimezoneOffset();
    return Math.min(jan, jul) === d.getTimezoneOffset();
  }

  function getETNow() {
    var now = new Date();
    var utc = now.getTime() + now.getTimezoneOffset() * 60000;
    var offset = isDST(now) ? -4 : -5;
    return new Date(utc + 3600000 * offset);
  }

  function getDispatchDate(etNow) {
    var d = new Date(etNow);
    if (etNow.getHours() >= CUTOFF_HOUR_ET) d.setDate(d.getDate() + 1);
    if (d.getDay() === 0) d.setDate(d.getDate() + 1); // skip Sunday
    return d;
  }

  function addBusinessDays(date, days) {
    var d = new Date(date);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) added++;
    }
    return d;
  }

  function addWeekdays(date, days) {
    var d = new Date(date);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    return d;
  }

  function formatDate(d) {
    var DAYS   = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var n = d.getDate();
    var suffix = n % 10 === 1 && n !== 11 ? 'st'
               : n % 10 === 2 && n !== 12 ? 'nd'
               : n % 10 === 3 && n !== 13 ? 'rd' : 'th';
    return DAYS[d.getDay()] + ', ' + MONTHS[d.getMonth()] + ' ' + n + suffix;
  }

function getCountdownText(etNow) {
    var cutoff = new Date(etNow);
    cutoff.setHours(CUTOFF_HOUR_ET, 0, 0, 0);
    if (cutoff <= etNow) cutoff.setDate(cutoff.getDate() + 1);
    var diff = cutoff - etNow;
    var hrs  = Math.floor(diff / 3600000);
    var mins = Math.floor((diff % 3600000) / 60000);
    if (hrs > 0) return 'Order within ' + hrs + ' hrs, ' + mins + ' min';
    return 'Order within ' + mins + ' min';
  }

  function getSameDayWord(etNow) {
  var day  = etNow.getDay();   // 0 = Sun, 6 = Sat
  var hour = etNow.getHours();
  // Sunday all day, OR Saturday from noon onward → Monday
  if (day === 0) return 'Monday';
  if (day === 6 && hour >= 12) return 'Monday';
  return 'today';
}

  function resolveWarehouse(zip) {
    var stock = window.ezShipData.warehouseStock;
    var nearest = zip ? ZIP_MAP[zip.substring(0, 2)] : null;
    if (nearest && stock[nearest]) return { warehouse: nearest, isNearest: true };
    for (var i = 0; i < FALLBACK_ORDER.length; i++) {
      if (stock[FALLBACK_ORDER[i]]) return { warehouse: FALLBACK_ORDER[i], isNearest: false };
    }
    if (window.ezShipData.inventoryQty > 0) return { warehouse: null, isPartner: true };
    return null;
  }

function getStateFromZip(zip) {
  if (!zip) return null;
  var p = zip.substring(0, 2);
  var map = {
    '01':'MA','02':'MA','03':'NH','04':'ME','05':'VT','06':'CT',
    '07':'NJ','08':'NJ','09':'NJ','10':'NY','11':'NY','12':'NY',
    '13':'NY','14':'NY','15':'PA','16':'PA','17':'PA','18':'PA',
    '19':'PA','20':'DC','21':'MD','22':'VA','23':'VA','24':'VA',
    '25':'WV','26':'WV','27':'NC','28':'NC','29':'SC','30':'GA',
    '31':'GA','32':'FL','33':'FL','34':'FL','35':'AL','36':'AL',
    '37':'TN','38':'TN','39':'MS','40':'KY','41':'KY','42':'KY',
    '43':'OH','44':'OH','45':'OH','46':'IN','47':'IN','48':'MI',
    '49':'MI','50':'IA','51':'IA','52':'IA','53':'WI','54':'WI',
    '55':'MN','56':'MN','57':'SD','58':'ND','59':'MT','60':'IL',
    '61':'IL','62':'IL','63':'MO','64':'MO','65':'MO','66':'KS',
    '67':'KS','68':'NE','69':'NE','70':'LA','71':'LA','72':'AR',
    '73':'OK','74':'OK','75':'TX','76':'TX','77':'TX','78':'TX',
    '79':'TX','80':'CO','81':'CO','82':'WY','83':'ID','84':'UT',
    '85':'AZ','86':'AZ','87':'NM','88':'NM','89':'NV','90':'CA',
    '91':'CA','92':'CA','93':'CA','94':'CA','95':'CA','96':'CA',
    '97':'OR','98':'WA','99':'AK'
  };
  return map[p] || null;
}

function getTransitDays(zip, warehouse) {
  if (!zip) return 3;
  var prefix = zip.substring(0, 2);
  var label = warehouse.replace('EZ Pools ', '');

  if (label === 'Memphis') {
    if (['80','81','82','83','84','85','86','87','88','89','90','91','92','93','94','95','96','97','98','99'].indexOf(prefix) > -1) return 4;
    if (['60','61','62','63','64','65','66','67','68','69','70','71','72','73','74','75','76','77','78','79'].indexOf(prefix) > -1) return 2;
    if (['28','29','30','31','32','33','34','35','36','37','38','39','40','41','42','43','44','45','46','47','48','49'].indexOf(prefix) > -1) return 1;
    return 2; // Northeast
  }

  if (label === 'New Jersey') {
    if (['80','81','82','83','84','85','86','87','88','89','90','91','92','93','94','95','96','97','98','99'].indexOf(prefix) > -1) return 5;
    if (['60','61','62','63','64','65','66','67','68','69'].indexOf(prefix) > -1) return 3;
    if (['28','29','30','31','32','33','34','35','36','37','38','39','40','41','42','43','44','45','46','47','48','49','50','51','52','53','54','55','56','57','58','59'].indexOf(prefix) > -1) return 2;
    return 1; // Northeast
  }

  if (label === 'Colorado') {
    if (['90','91','92','93','94','95','96','97','98','99'].indexOf(prefix) > -1) return 2;
    if (['80','81','82','83','84','85','86','87','88','89'].indexOf(prefix) > -1) return 1;
    if (['60','61','62','63','64','65','66','67','68','69','70','71','72','73','74','75','76','77','78','79'].indexOf(prefix) > -1) return 3;
    return 4; // Northeast
  }

  if (label === 'Jacksonville') {
    if (['80','81','82','83','84','85','86','87','88','89','90','91','92','93','94','95','96','97','98','99'].indexOf(prefix) > -1) return 4;
    if (['60','61','62','63','64','65','66','67','68','69','70','71','72','73','74','75','76','77','78','79'].indexOf(prefix) > -1) return 3;
    if (['28','29','30','31','32','33','34','35','36','37','38','39','40','41','42','43','44','45','46','47','48','49'].indexOf(prefix) > -1) return 2;
    return 3; // Northeast
  }

  return 3;
}

  // ─── Render ───────────────────────────────────────────────────────────
function render(zip) {
    var result = resolveWarehouse(zip);
    var qty    = window.ezShipData.inventoryQty;
    var etNow  = getETNow();

    if (!result) {
      document.getElementById('ez-ship-header').innerHTML    = '<span style="color:#cc0000;">❌ Out of Stock</span>';
      document.getElementById('ez-ship-date').innerHTML      = '';
      document.getElementById('ez-ship-countdown').innerHTML = '';
      document.getElementById('ez-ship-stock').innerHTML     = '';
      return;
    }

    var arrival, countdown;
    if (result.isPartner) {
      // No same-day cutoff: the branch ships on its own schedule.
      arrival   = addWeekdays(etNow, PARTNER_HANDLING_DAYS + PARTNER_TRANSIT_DAYS);
      countdown = 'Ships within 1-2 business days';
    } else {
      var transit  = getTransitDays(zip, result.warehouse);
      var dispatch = getDispatchDate(etNow);
      arrival   = transit === 0 ? dispatch : addBusinessDays(dispatch, transit);
      countdown = getCountdownText(etNow);
    }

    var stockColor = qty <= 5 ? '#cc7700' : '#2e7d32';
    var stockText  = qty <= 5 ? qty + ' left in stock' : qty + ' in stock';

    document.getElementById('ez-ship-header').innerHTML = result.isPartner
  ? '<strong>Free Shipping</strong>'
  : '<img src="https://cdn.shopify.com/s/files/1/0686/2320/4665/files/v1_Fedex-logo.png?v=1774374271" style="height:18px; vertical-align:middle; margin-right:6px;"><strong>Free Express Shipping</strong>';

var state = getStateFromZip(zip);

document.getElementById('ez-ship-date').innerHTML =
  (result.isPartner ? 'Arrives by ' : '') +
  '<strong>' + formatDate(arrival) + '</strong>' +
  (zip ? ' to <span id="ez-inline-zip" style="color:#ff580d; font-weight:600; border-bottom:1px dashed #ff580d; cursor:pointer;">' + zip + (state ? ', ' + state : '') + '</span>' : '');

    document.getElementById('ez-ship-countdown').innerHTML =
      countdown ? countdown : 'Ships next business day';

    document.getElementById('ez-ship-stock').innerHTML =
      '<span style="color:' + stockColor + ';">● ' + stockText + '</span>';

// Local pickup callout — NJ warehouse + customer within ~50mi
// ─── Local pickup callout — NJ ───────────────────────────────────────
var pickupEl = document.getElementById('ez-ship-pickup');
if (pickupEl) {
  var nj = window.ezShipData.njPickup;
  if (nj && nj.available && nj.pickUpEnabled && isLocalToNJ(zip)) {
    var time = nj.pickUpTime || '';
    var isSameDay = time.toLowerCase().indexOf('hour') > -1;

    var iconSvg =
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;">' +
        '<path d="M3 9l1-6h16l1 6"></path>' +
        '<path d="M4 9v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9"></path>' +
        '<path d="M9 21v-8h6v8"></path>' +
      '</svg>';

    if (isSameDay) {
      var dayWord = getSameDayWord(etNow);
      pickupEl.innerHTML = iconSvg +
        '<span><strong>Pick up ' + dayWord + '</strong> in ' +
        '<button type="button" class="ez-pickup-link">Williamstown, NJ</button></span>';
    } else {
      pickupEl.innerHTML = iconSvg +
        '<span><strong>Pickup at </strong>' +
        '<button type="button" class="ez-pickup-link">Williamstown, NJ</button> &mdash; ' + time + '</span>';
    }
    pickupEl.classList.add('visible');

    var pickupLink = pickupEl.querySelector('.ez-pickup-link');
    if (pickupLink) {
      pickupLink.addEventListener('click', function () {
        if (window.ezPickupDrawer) window.ezPickupDrawer.open();
      });
    }
  } else {
    pickupEl.innerHTML = '';
    pickupEl.classList.remove('visible');
  }
}


    var inlineZip = document.getElementById('ez-inline-zip');
    if (inlineZip) inlineZip.addEventListener('click', showZipInput);

    document.getElementById('ez-change-zip-btn').textContent =
      zip ? 'Change Zip' : 'Add a Zip Code';
  }

  // ─── Zip input UI ────────────────────────────────────────────────────
  function showZipInput() {
    document.getElementById('ez-ship-zip-row').style.display       = 'none';
    document.getElementById('ez-ship-zip-input-row').style.display = 'flex';
    document.getElementById('ez-zip-error').style.display          = 'none';
    document.getElementById('ez-zip-input').value = '';
    document.getElementById('ez-zip-input').focus();
  }

  function hideZipInput() {
    document.getElementById('ez-ship-zip-row').style.display       = 'block';
    document.getElementById('ez-ship-zip-input-row').style.display = 'none';
    document.getElementById('ez-zip-error').style.display          = 'none';
  }

  function applyZip(zip) {
    sessionStorage.setItem(ZIP_STORAGE_KEY, zip);
    hideZipInput();
    render(zip);
  }

  // ─── IP lookup ───────────────────────────────────────────────────────
  function fetchZipFromIP(callback) {
    fetch('https://ipapi.co/json/')
      .then(function (r) { return r.json(); })
      .then(function (d) { callback(d.postal || null); })
      .catch(function ()  { callback(null); });
  }

  // ─── Init ────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {

    // Zip input events
    document.getElementById('ez-change-zip-btn').addEventListener('click', showZipInput);
    document.getElementById('ez-cancel-zip-btn').addEventListener('click', hideZipInput);

    document.getElementById('ez-update-zip-btn').addEventListener('click', function () {
      var val = document.getElementById('ez-zip-input').value.trim();
      if (val.length === 5 && !isNaN(val)) {
        applyZip(val);
      } else {
        document.getElementById('ez-zip-error').style.display = 'block';
      }
    });

    document.getElementById('ez-zip-input').addEventListener('keydown', function (e) {
      if (e.key === 'Enter')  document.getElementById('ez-update-zip-btn').click();
      if (e.key === 'Escape') hideZipInput();
    });

    document.getElementById('ez-zip-input').addEventListener('input', function () {
      var val = this.value.trim();
      document.getElementById('ez-zip-error').style.display =
        (val.length === 5 && !isNaN(val)) ? 'none' : 'block';
    });

// Kick off — check sessionStorage first
    var cached = sessionStorage.getItem(ZIP_STORAGE_KEY);
    if (cached) {
      setTimeout(function() { render(cached); }, 150);
    } else {
      fetchZipFromIP(function (zip) {
        if (zip) {
          sessionStorage.setItem(ZIP_STORAGE_KEY, zip);
          setTimeout(function() { render(zip); }, 150);
        } else {
          setTimeout(function() { render(null); }, 150);
        }
      });
    }
  });

})();